import * as React from "react";
import { ChevronRight } from "@bloomberg/media-ui-icons";

import Title from "~components/shared/title/Title";
import { TranslatedMessage, useTranslateMessage } from "~i18n/translate";
import { integrityError } from "~utils/moduleIntegrity";

import integrityCheck from "./TableOfContentsTitle.integrity";
import styles from "./styles.module.css";

export type TableOfContentsTitleProps = {
    date: string;
    archiveLink?: string;
};

export default function TableOfContentsTitle(props: TableOfContentsTitleProps) {
    const { date, archiveLink } = props;
    const integrity = integrityCheck(props);

    const translateMessage = useTranslateMessage();
    const issueTitle = translateMessage(
        {
            id: "issueTitle",
            defaultMessage: "{date} Issue",
        },
        { date }
    );

    if (integrity.length) return integrityError(integrity);

    return (
        <div className={styles.TableOfContentsTitle}>
            <Title title={issueTitle} />
            {archiveLink && (
                <a href={archiveLink} className={styles.archiveLink}>
                    <TranslatedMessage
                        id="browseTheArchive"
                        defaultMessage="Browse the Archive"
                    />
                    <ChevronRight />
                </a>
            )}
        </div>
    );
}
